import React, { useEffect } from 'react';

interface IHtmlBlock {
  className?: string;
}

type Window = {
  OneTrust: {
    initializeCookiePolicyHtml: () => void;
  };
} & typeof globalThis;

export const CookieList: React.FC<IHtmlBlock> = () => {
  useEffect(() => {
    const window = globalThis as Window;
    if (window.OneTrust) {
      window.OneTrust.initializeCookiePolicyHtml();
    }
  }, []);

  return <div id="ot-sdk-cookie-policy"></div>;
};
